import { render, staticRenderFns } from "./SkeletonNotice.vue?vue&type=template&id=ef7534a2&scoped=true&"
import script from "./SkeletonNotice.vue?vue&type=script&lang=js&"
export * from "./SkeletonNotice.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonNotice.vue?vue&type=style&index=0&id=ef7534a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7534a2",
  null
  
)

export default component.exports